import {Content1} from './Content1';
import {Content2} from './Content2';
import {Media1} from './Media1';
import {Media2} from './Media2';
import {Corporate1} from './Corporate1';

export {
  Content1,
  Content2,
  Media1,
  Media2,
  Corporate1
}


// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/index.js